import React from 'react';
import { Plus } from 'lucide-react';

interface NewMeetingButtonProps {
  onClick: () => void;
}

export const NewMeetingButton: React.FC<NewMeetingButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors font-medium"
    >
      <Plus className="w-4 h-4" />
      <span>Nouveau rendez-vous</span>
    </button>
  );
};